"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUrlParams = void 0;
const parseParam = (param) => param === null || param === void 0 ? void 0 : param.toString();
const parseSessionParams = (sessionParams) => JSON.parse(sessionParams);
const getRawSessionParams = () => window.sessionStorage.getItem('mgm_signIn_params') || '{}';
const getSearchParams = () => parseSessionParams(getRawSessionParams());
/**
 * Helper function to return formatted URL params
 */
const getUrlParams = () => {
    const searchParams = getSearchParams();
    const clientId = parseParam(searchParams === null || searchParams === void 0 ? void 0 : searchParams.client_id);
    const redirectUri = parseParam(searchParams === null || searchParams === void 0 ? void 0 : searchParams.redirect_uri);
    const codeChallenge = parseParam(searchParams === null || searchParams === void 0 ? void 0 : searchParams.code_challenge);
    const state = parseParam(searchParams === null || searchParams === void 0 ? void 0 : searchParams.state);
    return {
        clientId,
        redirectUri,
        codeChallenge,
        state,
    };
};
exports.getUrlParams = getUrlParams;
